import { Box, Text } from 'grommet'
import { SVGProps } from 'react'
import { FaExclamation } from 'react-icons/fa'

export const StatusOne = ({ completed, ...props }: SVGProps<SVGSVGElement> & { completed?: boolean }) => {
  if (completed) {
    return (
      <div className="rounded-[50%] bg-white flex items-center justify-center h-6 w-6 outline outline-1 outline-[#379b6c] ">
        <div className="bg-[#379b6c] rounded-[50%] w-5 h-5 flex items-center justify-center">
          <Text color="#000" size="14px" weight={500}>
            1
          </Text>
        </div>
      </div>
    )
  }
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" {...props}>
      <rect fill="#F2F2F2" height="24" rx="12" width="24" />
      <path
        d="M9.638 17V15.782H11.878V8.81L10.128 9.902L9.54 8.824L12.298 7.13H13.32V15.782H15.42V17H9.638Z"
        fill="#323234"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.3"
      />
    </svg>
  )
}
export const StatusWarning = () => {
  return (
    <div className="rounded-[50%] bg-white flex items-center justify-center h-6 w-6 outline outline-1 outline-[#ff324e67] ">
      <Box align="center" background="#f8213d8d" className="rounded-full w-5 h-5" direction="row" justify="center">
        <FaExclamation color="white" stroke="black" strokeWidth={1} />
      </Box>
    </div>
  )
}

export const StatusTwo = ({ completed, ...props }: SVGProps<SVGSVGElement> & { completed?: boolean }) => {
  if (completed) {
    return (
      <Box
        align="center"
        background="white"
        className="rounded-[50%] h-6 w-6 outline outline-1 relative outline-[#379b6c] "
        direction="row"
        justify="center"
      >
        <Box className="absolute">
          <svg
            fill="none"
            height="20"
            style={{ backgroundColor: '#379b6c', borderRadius: '50%' }}
            viewBox="0 0 24 24"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M9.19 17V15.922L12.48 12.394C12.9373 11.8993 13.264 11.4513 13.46 11.05C13.6653 10.6487 13.768 10.2427 13.768 9.832C13.768 8.768 13.1427 8.236 11.892 8.236C10.94 8.236 10.086 8.59533 9.33 9.314L8.812 8.208C9.18533 7.844 9.66133 7.55467 10.24 7.34C10.8187 7.116 11.4207 7.004 12.046 7.004C13.0633 7.004 13.8427 7.23733 14.384 7.704C14.9347 8.17067 15.21 8.838 15.21 9.706C15.21 10.294 15.0653 10.868 14.776 11.428C14.496 11.988 14.0527 12.5853 13.446 13.22L11.01 15.782H15.602V17H9.19Z"
              fill="#000000"
              fillOpacity={1}
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="0.45"
              strokeWidth="0.3"
            />
          </svg>
        </Box>
      </Box>
    )
  }
  return (
    <svg
      fill="none"
      height="24"
      style={{ backgroundColor: '#E1E1E1', borderRadius: '50%' }}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.19 17V15.922L12.48 12.394C12.9373 11.8993 13.264 11.4513 13.46 11.05C13.6653 10.6487 13.768 10.2427 13.768 9.832C13.768 8.768 13.1427 8.236 11.892 8.236C10.94 8.236 10.086 8.59533 9.33 9.314L8.812 8.208C9.18533 7.844 9.66133 7.55467 10.24 7.34C10.8187 7.116 11.4207 7.004 12.046 7.004C13.0633 7.004 13.8427 7.23733 14.384 7.704C14.9347 8.17067 15.21 8.838 15.21 9.706C15.21 10.294 15.0653 10.868 14.776 11.428C14.496 11.988 14.0527 12.5853 13.446 13.22L11.01 15.782H15.602V17H9.19Z"
        fill="#000000"
        fillOpacity={0.4}
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="0.45"
        strokeWidth="0.3"
      />
    </svg>
  )
}

export const StatusTwoCurrent = ({ completed, ...props }: SVGProps<SVGSVGElement> & { completed?: boolean }) => {
  if (completed) {
    return (
      <div className="rounded-[50%] bg-white flex items-center justify-center h-6 w-6 outline outline-1 outline-[#379b6c] ">
        <div className="bg-[#379b6c] rounded-[50%] w-5 h-5 flex items-center justify-center">
          <Text color="#000" size="14px" weight={500}>
            2
          </Text>
        </div>
      </div>
    )
  }
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" {...props}>
      <rect fill="#F2F2F2" height="24" rx="12" width="24" />
      <path
        d="M9.19 17V15.922L12.48 12.394C12.9373 11.8993 13.264 11.4513 13.46 11.05C13.6653 10.6487 13.768 10.2427 13.768 9.832C13.768 8.768 13.1427 8.236 11.892 8.236C10.94 8.236 10.086 8.59533 9.33 9.314L8.812 8.208C9.18533 7.844 9.66133 7.55467 10.24 7.34C10.8187 7.116 11.4207 7.004 12.046 7.004C13.0633 7.004 13.8427 7.23733 14.384 7.704C14.9347 8.17067 15.21 8.838 15.21 9.706C15.21 10.294 15.0653 10.868 14.776 11.428C14.496 11.988 14.0527 12.5853 13.446 13.22L11.01 15.782H15.602V17H9.19Z"
        fill="#323234"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.3"
      />
    </svg>
  )
}

export const StatusThree = ({ completed, ...props }: SVGProps<SVGSVGElement> & { completed?: boolean }) => {
  if (completed) {
    return (
      <div className="rounded-[50%] bg-white flex items-center justify-center h-6 w-6 outline outline-1 outline-[#379b6c] ">
        <div className="bg-[#379b6c] rounded-[50%] w-5 h-5 flex items-center justify-center">
          <Text color="#000" size="14px" weight={500}>
            3
          </Text>
        </div>
      </div>
    )
  }
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" {...props}>
      <rect fill="#F2F2F2" height="24" rx="12" width="24" />
      <path
        d="M11.6914 17.14C11.0567 17.14 10.4781 17.0233 9.9554 16.79C9.44207 16.5473 9.00807 16.1973 8.6534 15.74L9.5494 14.844C9.76407 15.1707 10.0581 15.432 10.4314 15.628C10.8047 15.8147 11.2201 15.908 11.6774 15.908C12.1067 15.908 12.4754 15.8287 12.7834 15.67C13.1007 15.502 13.3481 15.2687 13.5254 14.97C13.7121 14.6713 13.8054 14.326 13.8054 13.934C13.8054 13.5327 13.7121 13.1873 13.5254 12.898C13.3481 12.5993 13.0961 12.3707 12.7694 12.212C12.4427 12.0533 12.0554 11.974 11.6074 11.974C11.4394 11.974 11.2714 11.988 11.1034 12.016C10.9354 12.0347 10.7721 12.0673 10.6134 12.114L11.1734 11.358C11.3507 11.274 11.5421 11.2087 11.7474 11.162C11.9527 11.1153 12.1581 11.092 12.3634 11.092C12.8861 11.092 13.3527 11.2133 13.7634 11.456C14.1834 11.6987 14.5147 12.0393 14.7574 12.478C15.0094 12.9167 15.1354 13.4253 15.1354 14.004C15.1354 14.62 14.9861 15.166 14.6874 15.642C14.3981 16.1087 13.9967 16.4773 13.4834 16.748C12.9701 17.0093 12.3727 17.14 11.6914 17.14ZM10.6134 12.114V11.316L13.4554 8.082L15.0234 8.068L12.0974 11.386L10.6134 12.114ZM9.1154 8.46V7.284H15.0234V8.068L13.8754 8.46H9.1154Z"
        fill="#323234"
      />
    </svg>
  )
}

export const StatusFour = ({ completed, ...props }: SVGProps<SVGSVGElement> & { completed?: boolean }) => {
  if (completed) {
    return (
      <div className="rounded-[50%] bg-white flex items-center justify-center h-6 w-6 outline outline-1 outline-[#379b6c] ">
        <div className="bg-[#379b6c] rounded-[50%] w-5 h-5 flex items-center justify-center">
          <Text color="#000" size="14px" weight={500}>
            4
          </Text>
        </div>
      </div>
    )
  }
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" {...props}>
      <rect fill="#F2F2F2" height="24" rx="12" width="24" />
      <path
        d="M7.77841 13.654L11.3204 7.284H12.8044L9.19241 13.654H7.77841ZM7.77841 14.466V13.654L8.33841 13.29H15.2264V14.466H7.77841ZM12.5244 17V10.574H13.8264V17H12.5244Z"
        fill="#323234"
      />
    </svg>
  )
}

export const PauseIcon = () => (
  <svg fill="none" height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#EEEEEE" height="22" rx="11" width="22" />
    <g clipPath="url(#clip0_222_17244)">
      <path
        d="M8.25 5C7.78587 5 7.34075 5.18437 7.01256 5.51256C6.68437 5.84075 6.5 6.28587 6.5 6.75V15.25C6.5 15.7141 6.68437 16.1592 7.01256 16.4874C7.34075 16.8156 7.78587 17 8.25 17C8.71413 17 9.15925 16.8156 9.48744 16.4874C9.81563 16.1592 10 15.7141 10 15.25V6.75C10 6.28587 9.81563 5.84075 9.48744 5.51256C9.15925 5.18437 8.71413 5 8.25 5ZM9 15.25C9 15.4489 8.92098 15.6397 8.78033 15.7803C8.63968 15.921 8.44891 16 8.25 16C8.05109 16 7.86032 15.921 7.71967 15.7803C7.57902 15.6397 7.5 15.4489 7.5 15.25V6.75C7.5 6.55109 7.57902 6.36032 7.71967 6.21967C7.86032 6.07902 8.05109 6 8.25 6C8.44891 6 8.63968 6.07902 8.78033 6.21967C8.92098 6.36032 9 6.55109 9 6.75V15.25Z"
        fill="black"
      />
      <path
        d="M13.75 5C13.2859 5 12.8408 5.18437 12.5126 5.51256C12.1844 5.84075 12 6.28587 12 6.75V15.25C12 15.7141 12.1844 16.1592 12.5126 16.4874C12.8408 16.8156 13.2859 17 13.75 17C14.2141 17 14.6592 16.8156 14.9874 16.4874C15.3156 16.1592 15.5 15.7141 15.5 15.25V6.75C15.5 6.28587 15.3156 5.84075 14.9874 5.51256C14.6592 5.18437 14.2141 5 13.75 5ZM14.5 15.25C14.5 15.4489 14.421 15.6397 14.2803 15.7803C14.1397 15.921 13.9489 16 13.75 16C13.5511 16 13.3603 15.921 13.2197 15.7803C13.079 15.6397 13 15.4489 13 15.25V6.75C13 6.55109 13.079 6.36032 13.2197 6.21967C13.3603 6.07902 13.5511 6 13.75 6C13.9489 6 14.1397 6.07902 14.2803 6.21967C14.421 6.36032 14.5 6.55109 14.5 6.75V15.25Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_222_17244">
        <rect fill="white" height="12" transform="translate(5 5)" width="12" />
      </clipPath>
    </defs>
  </svg>
)

export const DisabledIcon = () => (
  <svg fill="none" height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#EEEEEE" height="22" rx="11" width="22" />
    <g clipPath="url(#clip0_222_17250)">
      <path
        d="M11 5C9.81331 5 8.65328 5.35189 7.66658 6.01118C6.67989 6.67047 5.91085 7.60754 5.45673 8.7039C5.0026 9.80026 4.88378 11.0067 5.11529 12.1705C5.3468 13.3344 5.91825 14.4035 6.75736 15.2426C7.59648 16.0818 8.66558 16.6532 9.82946 16.8847C10.9933 17.1162 12.1997 16.9974 13.2961 16.5433C14.3925 16.0892 15.3295 15.3201 15.9888 14.3334C16.6481 13.3467 17 12.1867 17 11C16.9983 9.40923 16.3656 7.88411 15.2407 6.75926C14.1159 5.63441 12.5908 5.00172 11 5ZM11 6C12.1532 5.99908 13.271 6.39887 14.162 7.131L7.131 14.162C6.53129 13.4299 6.15183 12.5426 6.03681 11.6032C5.92179 10.6639 6.07593 9.71117 6.4813 8.85602C6.88666 8.00087 7.52657 7.27844 8.32654 6.77282C9.12651 6.2672 10.0536 5.9992 11 6ZM11 16C9.84677 16.0009 8.72904 15.6011 7.838 14.869L14.869 7.838C15.4687 8.57008 15.8482 9.45744 15.9632 10.3968C16.0782 11.3361 15.9241 12.2888 15.5187 13.144C15.1133 13.9991 14.4734 14.7216 13.6735 15.2272C12.8735 15.7328 11.9464 16.0008 11 16Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_222_17250">
        <rect fill="white" height="12" transform="translate(5 5)" width="12" />
      </clipPath>
    </defs>
  </svg>
)

export const ProceedIcon = () => (
  <svg fill="none" height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#EEEEEE" height="22" rx="11" width="22" />
    <g clipPath="url(#clip0_222_17256)">
      <path
        d="M12 16.015C11.805 16.015 11.61 15.975 11.42 15.9C10.855 15.665 10.5 15.14 10.495 14.525V13.495H6.985C5.89 13.495 5 12.595 5 11.49V10.5C5 9.395 5.89 8.495 6.985 8.495H10.5V7.465C10.5 6.85 10.855 6.325 11.425 6.09C11.99 5.855 12.615 5.98 13.045 6.415L16.405 9.58L16.415 9.59C17.19 10.365 17.19 11.625 16.415 12.4L13.03 15.585C12.75 15.865 12.38 16.015 12 16.015ZM6.985 9.495C6.44 9.495 6 9.945 6 10.5V11.49C6 12.045 6.445 12.495 6.985 12.495H11C11.275 12.495 11.5 12.72 11.5 12.995V14.525C11.5 14.825 11.735 14.945 11.805 14.975C11.875 15.005 12.125 15.085 12.34 14.87L15.725 11.685C16.095 11.315 16.1 10.69 15.72 10.305L12.355 7.14C12.13 6.915 11.88 6.995 11.81 7.02C11.74 7.05 11.505 7.17 11.505 7.47V8.995C11.505 9.27 11.28 9.495 11.005 9.495H6.985Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_222_17256">
        <rect fill="white" height="12" transform="translate(5 5)" width="12" />
      </clipPath>
    </defs>
  </svg>
)
